import * as TypeGraphQL from "type-graphql";
export var TradeScalarFieldEnum;
(function (TradeScalarFieldEnum) {
    TradeScalarFieldEnum["id"] = "id";
    TradeScalarFieldEnum["alpacaAccountId"] = "alpacaAccountId";
    TradeScalarFieldEnum["signal"] = "signal";
    TradeScalarFieldEnum["strategy"] = "strategy";
    TradeScalarFieldEnum["analysis"] = "analysis";
    TradeScalarFieldEnum["summary"] = "summary";
    TradeScalarFieldEnum["confidence"] = "confidence";
    TradeScalarFieldEnum["timestamp"] = "timestamp";
    TradeScalarFieldEnum["createdAt"] = "createdAt";
    TradeScalarFieldEnum["updatedAt"] = "updatedAt";
    TradeScalarFieldEnum["status"] = "status";
    TradeScalarFieldEnum["symbol"] = "symbol";
    TradeScalarFieldEnum["entryPrice"] = "entryPrice";
    TradeScalarFieldEnum["exitPrice"] = "exitPrice";
    TradeScalarFieldEnum["entryQty"] = "entryQty";
    TradeScalarFieldEnum["exitQty"] = "exitQty";
    TradeScalarFieldEnum["entryValue"] = "entryValue";
    TradeScalarFieldEnum["exitValue"] = "exitValue";
    TradeScalarFieldEnum["entryTime"] = "entryTime";
    TradeScalarFieldEnum["exitTime"] = "exitTime";
    TradeScalarFieldEnum["pnlAmount"] = "pnlAmount";
    TradeScalarFieldEnum["pnlPercent"] = "pnlPercent";
    TradeScalarFieldEnum["durationMinutes"] = "durationMinutes";
    TradeScalarFieldEnum["marketPhase"] = "marketPhase";
    TradeScalarFieldEnum["marketVolatility"] = "marketVolatility";
    TradeScalarFieldEnum["sessionHorizonMinutes"] = "sessionHorizonMinutes";
    TradeScalarFieldEnum["thresholdsJson"] = "thresholdsJson";
})(TradeScalarFieldEnum || (TradeScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(TradeScalarFieldEnum, {
    name: "TradeScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=TradeScalarFieldEnum.js.map